import { Navigation, Scrollbar } from "swiper/modules";
import { SwiperOptions } from "swiper/types";

export const newsCardSliderOptions: SwiperOptions = {
  spaceBetween: 20,
  modules: [Scrollbar],
  slidesPerView: 2.25,
  slidesPerGroup: 1,
  grabCursor: true,
  speed: 700,
  direction: "horizontal",
  observer: true,
  mousewheel: {
    forceToAxis: true,
  },
  scrollbar: {
    enabled: true,
    draggable: true,
    hide: false,
    el: ".swiper-scrollbar",
  },
  injectStyles: [
    `
       .swiper {
        overflow: visible;     
      } 
    `,
  ],
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 35,
    },
    768: {
      slidesPerView: 2.1,
      spaceBetween: 35,
    },
    1190: {
      slidesPerView: 2.1,
    },
    1500: {
      slidesPerView: 2.25,
    },
    1600: {
      slidesPerView: 2.75,
    },
  },
};
